import { MenuItemProps, styled } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";

import MenuItem from "./MenuItem";

interface IconMenuItemProps extends MenuItemProps {
  icon: React.ReactNode;
  color?: string;
  children: React.ReactNode;
  onClick?: (() => void) | undefined;
}

const StyledMenuItem = styled(MenuItem)(() => {
  return {
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 400,
    "& .MuiListItemIcon-root": {
      minWidth: "32px",
      marginRight: "8px",
    },
  };
});

export const IconMenuItem: React.FC<IconMenuItemProps> = ({
  icon,
  disabled,
  color,
  children,
  onClick,
  ...props
}) => {
  return (
    <StyledMenuItem disabled={!!disabled} onClick={onClick} sx={{ color: { color } }} {...props}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      {children}
    </StyledMenuItem>
  );
};

export default IconMenuItem;
